import React, { useEffect, useState } from "react";
import { DataTable, Loader, UnAuth } from "../components";
import { get, isNotNullOrEmpty } from "../functions";
// import electionResults from "./data.json";

const ElectionResult = () => {
  const [positions, setPositions] = useState([]);
  const [pollingStations, setPollingStations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unauth, setUnAuth] = useState(false);

  const filterPositions = (results, positions, stations) => {
    let positionArr = positions;
    positionArr.map((positionElement, positionIndex) => {
      positionElement.candidate.map((candidateElement, candidateIndex) => {
        candidateElement = { ...candidateElement, stations: [], totalVotes: 0 };
        let totalVotes = 0;
        stations.map((stationElement) => {
          let resultObj = results.filter(
            (resultsElement) =>
              resultsElement.candidate_id === candidateElement.id &&
              resultsElement.polling_station_id === stationElement.id
          )[0];
          let voteCount = isNotNullOrEmpty(resultObj)
            ? resultObj.vote_count
            : 0;
          totalVotes += voteCount;
          candidateElement.stations.push({
            stationName: stationElement.name,
            stationCode: stationElement.code,
            voteCount,
          });
        });
        candidateElement.totalVotes = totalVotes;
        positionArr[positionIndex].candidate[candidateIndex] = candidateElement;
      });
    });
    setPositions(positionArr);
  };

  const getElectionResults = async () => {
    const response = await get("/public/election-result");
    if (response?.status === "Success") {
      const { results, positions, polling_stations } = response.data;
      filterPositions(results, positions, polling_stations);
      setPollingStations(polling_stations);
    } else if (
      response?.status === "Error" &&
      response?.message === "Unauthorized access."
    ) {
      setUnAuth(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    getElectionResults();
  }, []);

  useEffect(() => {
    console.log(positions);
  }, [positions]);

  if (unauth) {
    return <UnAuth />;
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <main>
      <section className="max-w-full mt-8">
        <h1 className="heading !mb-0">Election Result</h1>
        <section className="grid grid-cols-1 p-8 overflow-auto w-full max-md:hidden">
          {positions.map((positionElement, positionIndex) => {
            let positionName = positionElement.name;
            return (
              <DataTable
                key={positionIndex}
                headCells={[positionName]}
                colSpan={pollingStations.length + 2}
              >
                <tr className="*:font-semibold *:text-center">
                  <td>Candidate Name / Polling Station</td>
                  {pollingStations.map((stationElement, stationIndex) => {
                    let stationName = stationElement.name;
                    return <td key={stationIndex}>{stationName}</td>;
                  })}
                  <td>Grand Total</td>
                </tr>
                {positionElement.candidate.map(
                  (candidateElement, candidateIndex) => {
                    let candidateName = candidateElement.name;
                    return (
                      <tr key={candidateIndex}>
                        <td>{candidateName}</td>
                        {candidateElement.stations.map(
                          ({ voteCount }, stationIndex) => {
                            return (
                              <td key={stationIndex} className="text-center">
                                {voteCount}
                              </td>
                            );
                          }
                        )}
                        <td className="text-center">
                          {candidateElement.totalVotes}
                        </td>
                      </tr>
                    );
                  }
                )}
              </DataTable>
            );
          })}
        </section>
        <section className="grid grid-cols-1 max-sm:p-3 sm:p-8 overflow-auto w-full md:hidden">
          {positions.map((positionElement, positionIndex) => {
            let positionName = positionElement.name;
            return (
              <DataTable
                key={positionIndex}
                headCells={[positionName]}
                colSpan={pollingStations.length + 2}
              >
                <tr className="*:font-semibold *:text-center">
                  <td>Candidate Name</td>
                  <td>Grand Total</td>
                </tr>
                {positionElement.candidate.map(
                  (candidateElement, candidateIndex) => {
                    let candidateName = candidateElement.name;
                    return (
                      <tr key={candidateIndex}>
                        <td>
                          {candidateName}
                          <div className="border-t border-darkgrey pt-2 mt-2 flex flex-wrap">
                            {candidateElement.stations.map(
                              ({ stationCode, voteCount }, stationIndex) => {
                                return (
                                  <span
                                    key={stationIndex}
                                    className="mr-2 whitespace-nowrap"
                                  >
                                    {stationCode}: {voteCount}
                                  </span>
                                );
                              }
                            )}
                          </div>
                        </td>
                        <td className="text-center">
                          {candidateElement.totalVotes}
                        </td>
                      </tr>
                    );
                  }
                )}
              </DataTable>
            );
          })}
        </section>
      </section>
    </main>
  );
};

export default ElectionResult;
